export default __webpack_public_path__ + "static/media/SampleProductPromotion.6da4582b.svg";